'use client';
import './CarModelDetailsCarousel.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCreative, Navigation } from 'swiper/modules';
import CarModelPrevNextButtons from './PrevNextButtons/CarModelPrevNextButtons';
import React from 'react';
import cn from 'classnames';

import { Image } from '@sitecore-jss/sitecore-jss-react';

export default function Carousel({ marks, swiperRef, setSlideIndex }) {
  const isOpen = marks.some((el) => el.open);

  const handlePrev = () => {
    if (swiperRef.current.activeIndex === 0) {
      setSlideIndex(marks.length - 1);
    } else {
      setSlideIndex(swiperRef.current.activeIndex - 1);
    }
  };

  const handleNext = () => {
    if (swiperRef.current.activeIndex === marks.length - 1) {
      setSlideIndex(0);
    } else {
      setSlideIndex(swiperRef.current.activeIndex + 1);
    }
  };

  return (
    <div className={'car-model-details-carousel'}>
      <div className={'wrapper-carousel'}>
        <Swiper
          onSwiper={(swiper) => (swiperRef.current = swiper)}
          onSlideChange={(swiper) => setSlideIndex(swiper.activeIndex)}
          grabCursor={false}
          effect={'creative'}
          creativeEffect={{
            prev: {
              shadow: true,
              translate: ['-105%', 0, -1],
            },
            next: {
              translate: ['105%', 0, 0],
            },
          }}
          modules={[EffectCreative, Navigation]}
        >
          {marks.map((item) => {
            return (
              <SwiperSlide key={item.fields.id.value}>
                <div className={'image'}>
                  <Image field={item.fields.image.value} alt={item.fields.title.value} fill />
                </div>
                <div className={cn('block', isOpen && 'block_show')}>
                  <h3 className={'block_title'}>{item?.fields.title.value}</h3>
                  <p className={'block_text'}>{item?.fields.text.value}</p>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <CarModelPrevNextButtons isOpen={isOpen} onPrev={handlePrev} onNext={handleNext} />
      </div>
    </div>
  );
}
